import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  CurrencyTypeActions,
  UiActions
} from '../../../store/actions';
import { DataClientService } from '../../../services/data-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { ApiResponseStatus, CurrencyType, GenericErrorType, StepsClientTypes, StepsNotClientTypes } from '../../../shared/enums';
import { environment } from 'src/environments/environment';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { RequestCurrencyType } from 'src/app/shared/interfaces';
import { ContextService } from 'src/app/services/context.service';
import { FlagrService } from 'src/app/services/flagr/flagr.service';
import { EnumService } from 'src/app/services/enum.service';
import { AccountFormatService } from 'src/app/services/account-format.service';

@Component({
  selector: 'app-currency-type',
  templateUrl: './currency-type.component.html',
  styleUrls: ['../../../global.scss', './currency-type.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CurrencyTypeComponent implements OnInit, OnDestroy {
  currencySelected: number;
  dataService: DataNotClientService | DataClientService;
  privateMode: boolean;
  currencyType$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.currencyType)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataClientService: DataClientService,
    private dataNotClientService: DataNotClientService,
    private dataDogService: DatadogService,
    private contextService: ContextService,
    private flagrService: FlagrService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private enumService: EnumService,
    public accountFormatService: AccountFormatService
  ) {}

  currencyTypeSuscription = this.currencyType$.subscribe(({ response, error }) => {
    // error case
    if (error) {
      this.redirectInError();
    }

    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.store.dispatch(CurrencyTypeActions.cleanState());
        if (this.contextService.isPublicOmni1()) {
          if (environment.production) {
            return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_FACE_RECOGNITION }));
          } else {
            this.flagrEvaluation();
          }
        } else {
          this.nextStep();
        }
      } else if (response.client.operationState.code === ApiResponseStatus.FAIL) {
        if (this.contextService.isPublicOmni1()) {
          this.dataNotClientService.setGenericErrorType(GenericErrorType.ABR_YELLOW_DERIVATION);
          return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
        } else {
          this.nextStep();
        }
      } else {
        this.redirectInError();
      }
    }
    });

  ngOnInit() {
    this.setService();
    this.dataService.setAccountType('24');
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
  }

  ngOnDestroy() {
    this.currencyTypeSuscription.unsubscribe();
  }

  async flagrEvaluation(): Promise<void> {
    let dniIsInFlagr = true;
    let nextStep: StepsNotClientTypes = StepsNotClientTypes.STEP_TERMS_CONDITIONS;
    // Se evalua si FLAGR esta prendido o no por static
    if (this.dataNotClientService.getUseFlagr()) {
      dniIsInFlagr = await this.flagrService.canShowFaceID();
    }
    if (!dniIsInFlagr) {
      nextStep = StepsNotClientTypes.STEP_FACE_RECOGNITION;
    }
    this.store.dispatch(UiActions.Navigate({ step: nextStep }));
  }

  setService() {
    this.privateMode = environment.mode === 'IN' || environment.mode === 'PF' ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {
      is_joint_account: this.dataService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataService.getWorkActivityType() ? this.dataService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataService.getDateEntryWork() ? this.dataService.getDateEntryWork() : 'No informado',
        companyName: this.dataService.getCompanyName() ? this.dataService.getCompanyName() : 'No informado',
        rucCompany: this.dataService.getRucCompany() ? this.dataService.getRucCompany() : 'No informado',
        profession: this.dataService.getProfession() ? this.dataService.getProfession() : 'No informado'
      }
    };
    this.store.dispatch(TagPage({text: 'currency-account-type-selection', extras: googleAnalytics}));
  }

  continue() {
    this.loadingService.loading = true;
    this.dataService.setCurrencyType(this.currencySelected);
    const request: RequestCurrencyType = {
      currency: this.currencySelected,
      idProduct: `900-4-${this.enumService.getAccountType(this.accountFormatService.getName())}`
    };
    this.dataDogService.addCustomEvent(`Currency ${this.currencySelected} selected`, environment.mode, { channel: 'client' });
    this.store.dispatch(CurrencyTypeActions.getcurrencyType({ request }));
  }

  accountTypeSelected(type) {
    this.currencySelected = Number(CurrencyType[type]);
  }

  nextStep() {
    const nextStep: StepsClientTypes|StepsNotClientTypes = this.privateMode ?
    StepsClientTypes.STEP_TERMS_CONDITIONS : StepsNotClientTypes.STEP_TERMS_CONDITIONS;
    this.store.dispatch(UiActions.Navigate({ step: nextStep }));
  }

  redirectInError() {
    const nextStep = this.privateMode ? StepsClientTypes.STEP_SERVICE_ERROR : StepsNotClientTypes.STEP_SERVICE_ERROR;
    this.store.dispatch(CurrencyTypeActions.cleanState());
    return this.store.dispatch(UiActions.Navigate({ step: nextStep }));
  }
}
